import { render } from "./Profile.vue?vue&type=template&id=46b71ed0&scoped=true&lang=html"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=46b71ed0&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-46b71ed0"

export default script